import { Button } from '@affine/component/ui/button';
import { Modal } from '@affine/component/ui/modal';
import { useI18n } from '@affine/i18n';

import * as styles from './choose-rows-dialog.css';
import { ChooseRowsScene } from './choose-rows-scene';

/**
 * A manual run over a table runs the rows chosen in it. Run without a chosen
 * row opens this dialog: the scene shows how to tick rows, and a table in
 * another document can be opened from here.
 */
export const ChooseRowsDialog = ({
  open,
  onOpenChange,
  onOpenTable,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** Set when the source table lives in another document. */
  onOpenTable?: () => void;
}) => {
  const t = useI18n();
  return (
    <Modal
      animation="none"
      closeButtonOptions={{
        'aria-label': t['com.streamlain.streamlain.common.close'](),
        className: styles.closeButton,
      }}
      contentOptions={{ className: styles.content }}
      description={t['com.streamlain.automation.run-rows.dialog.description']()}
      descriptionClassName={styles.description}
      headerClassName={styles.header}
      onOpenChange={onOpenChange}
      open={open}
      title={t['com.streamlain.automation.run-rows.dialog.title']()}
      width={520}
    >
      <ChooseRowsScene className={styles.scene} />
      <div
        className={styles.actions}
        data-single={onOpenTable ? undefined : ''}
      >
        <Button
          className={styles.action}
          onClick={() => onOpenChange(false)}
          variant={onOpenTable ? 'secondary' : 'primary'}
        >
          {t['com.streamlain.automation.run-rows.dialog.confirm']()}
        </Button>
        {onOpenTable ? (
          <Button
            className={styles.action}
            data-testid="choose-rows-open-table"
            onClick={() => {
              onOpenChange(false);
              onOpenTable();
            }}
            variant="primary"
          >
            {t['com.streamlain.automation.run-rows.dialog.open-table']()}
          </Button>
        ) : null}
      </div>
    </Modal>
  );
};
